import { all } from "redux-saga/effects";
import auth from "./auth";
import user from "./user";
import statics from "./statics";
import enrollment from "./enrollment";
import course from "./course";
import file from "./file";
import quiz from "./quiz";

export default function* rootSaga() {
  yield all([
    auth(),
    user(),
    statics(),
    enrollment(),
    course(),
    file(),
    quiz()
  ]);
}
